import type { IInitializePVSelectionState } from '../hooks/useInitializePVSelectionState';
import type { IInitializePVProviderData } from '../hooks/useInitializePVProviderData';
import type { ReactNode } from 'react';

import { useInitializePVSelectionState } from '../hooks/useInitializePVSelectionState';
import { useInitializePVProviderData } from '../hooks/useInitializePVProviderData';
import { createContext, useContext, useMemo } from 'react';

export interface IPVTableContext extends IInitializePVProviderData {
  pvSelectionState: IInitializePVSelectionState;
}
export interface IPVTableProvider {
  children: ReactNode;
}

export const PVTableContext = createContext<IPVTableContext | undefined>(undefined);

export const PVTableProvider: React.FC<IPVTableProvider> = ({ children }) => {
  const pvProviderData = useInitializePVProviderData();
  const pvSelectionState = useInitializePVSelectionState(pvProviderData.products);

  const contextValue = useMemo(
    () => ({
      pvSelectionState,
      ...pvProviderData,
    }),
    [pvProviderData, pvSelectionState],
  );

  return <PVTableContext.Provider value={contextValue}>{children}</PVTableContext.Provider>;
};

export const usePVTableContext = () => {
  const context = useContext(PVTableContext);
  if (!context) {
    throw new Error('usePVTableContext must be used within a PVTableProvider');
  }
  return context;
};
